import axios from 'axios';

export const getIndustries = (data = null) => axios.get(`company/industries/get`, data).then(({ data }) => data);